export default "__VITE_ASSET__h5fhoLVux4jNUSCVsDpS0w__"